import { createReducer, on } from '@ngrx/store';
import { courseActions } from '../actions/course.actions';
import { Course } from '../models';
import { BaseState, StateManager } from '@app/store/shared';

export interface CourseState {
    items: Record<string, BaseState<Course>>;
}

export const initialState: CourseState = {
    items: {},
};

export const courseReducer = createReducer(
    initialState,
    on(courseActions.getCourse, (state, payload): CourseState => {
        if (state.items[payload.id] === undefined) {
            return {
                ...state,
                items: {
                    ...state.items,
                    [payload.id]: StateManager.initial(true),
                },
            };
        }

        return state;
    }),
    on(courseActions.getCourseSuccess, (state, { course }): CourseState => {
        return {
            ...state,
            items: {
                ...state.items,
                [course.id]: StateManager.setLoaded(state.items[course.id], course),
            },
        };
    }),
    on(courseActions.getCourseError, (state, { id }): CourseState => ({
        ...state,
        items: {
            ...state.items,
            [id]: StateManager.setError(state.items[id]),
        },
    })),
    on(courseActions.clear, (): CourseState => ({
        ...initialState,
    })),
);
